import type { Routes } from '@angular/router';

export const GALLERY_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/gallery/views/gallery/gallery.component').then((m) => m.GalleryComponent),
    },
];
